import CallLogCallCtrlUI from './CallLogCallCtrlUI';

export default CallLogCallCtrlUI;
